/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/share/components/IFrameEmbedView.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { getIFrameEmbedCode } from 'embedded-academy-lib';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { View } from 'foundations-components/transitional/components/View';
import { useTheme } from 'foundations-theming/utils';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo, useRef, useState } from 'react';
import { useCurrentVideoTime } from '../../video/components/VideoPlayerWithControls.migrated';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import { Text } from 'foundations-components/components/Text';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IFrameEmbedView = ({
  lessonId,
  contentId,
  shortId,
  language
}) => {
  const theme = useTheme();
  const {
    currentVideoTime
  } = useCurrentVideoTime();
  const {
    current: videoTimeWhenModalWasOpened
  } = useRef(Math.round(currentVideoTime));
  const [startAtTimeSelected, setStartAtTimeSelected] = useState(false);
  const [startAtTime, setStartAtTime] = useState();
  const embedCode = useMemo(() => getIFrameEmbedCode({
    lessonId,
    contentId,
    shortId,
    language,
    startTime: startAtTimeSelected ? startAtTime || videoTimeWhenModalWasOpened : 0
  }), [lessonId, contentId, shortId, language, startAtTimeSelected, startAtTime, videoTimeWhenModalWasOpened]);
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "start",
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: InfoIcon
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.iframe.description"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: embedCode
      },
      style: {
        marginBlockEnd: theme.space['200']
      }
    }), /*#__PURE__*/_jsx(Checkbox, {
      checked: startAtTimeSelected,
      onChange: e => setStartAtTimeSelected(e.target.checked),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.embedModal.startTimeCheckbox"
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text('learningCenter.embedModal.startTimeLabel'),
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(NumberInput, {
        disabled: !startAtTimeSelected,
        onChange: e => {
          setStartAtTime(+e.target.value);
        },
        value: startAtTime || videoTimeWhenModalWasOpened
      })
    }), /*#__PURE__*/_jsx(CopyTextArea, {
      buttonUse: "primary",
      use: "code",
      value: embedCode
    })]
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/share/components/IFrameEmbedView.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default IFrameEmbedView;